import { assignWith } from "lodash";

import { loadFilter } from "../../../common/urlFilterListener";
import type { AppThunk } from "../../../store/createAppThunk";
import { getDefaultSortDirection } from "../../../use-cases/manage/grid/utils/getDefaultSortDirection";
import { sortBookings } from "../../sorting/sortingActions";
import { initialFilterApplied, setFilter } from "../filterActions";
import type { FilterState } from "../filterReducer";

export const setFilterFromUrlWithSettingsFallback =
  (filterState: FilterState): AppThunk =>
  (dispatch) => {
    const { filter: filterFromURL, sorting: sortingFromURL } = loadFilter();

    if (sortingFromURL?.column) {
      dispatch(
        sortBookings(
          sortingFromURL.column,
          sortingFromURL.direction ??
            getDefaultSortDirection(sortingFromURL.column),
        ),
      );
    }

    const mergedFilterState = assignWith(
      { ...filterState },
      filterFromURL,
      (objValue, srcValue) => {
        return srcValue != null ? srcValue : objValue;
      },
    );
    dispatch(setFilter(mergedFilterState));
    dispatch(initialFilterApplied());
  };
